import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Blur from '../../hooks/UseCssBlur';

const OfferFAQs = ({ faqs, isAuthenticated }) => {
  const isPreview = window.location.href.indexOf('offer-preview') > -1;

  const showBlur = !isPreview && !isAuthenticated;
  return (
    <div className='max-width-div'>
      <div className='black-44 added-padded'>Frequently Asked Questions</div>
      <Blur radius={showBlur ? '5px' : '0'} transition='400ms'>
        <div className='faq-container'>
          {faqs.map(({ _id, question, answer }) => (
            <FAQItem key={_id} question={question} answer={answer} />
          ))}
        </div>
      </Blur>
    </div>
  );
};

class FAQItem extends Component {
  state = {
    answerHidden: true,
  };

  toggleAnswerHidden = () =>
    this.setState({
      answerHidden: !this.state.answerHidden,
    });

  render() {
    const { answerHidden } = this.state;
    const { answer, question } = this.props;

    return (
      <div
        className='faq-drawer w-clearfix'
        style={{ outline: 'none' }}
        onClick={this.toggleAnswerHidden}
        onKeyDown={(e) => e.keyCode === 13 && this.toggleAnswerHidden()}
        role='link'
        tabIndex={0}
      >
        <div className='faq-question'>{question}</div>
        {answerHidden ? (
          <div className='faq-carrot' />
        ) : (
          <div
            style={{ transform: 'rotateX(180deg)' }}
            className='faq-carrot'
          />
        )}
        {!answerHidden && <div className='faq-answer'>{answer}</div>}
      </div>
    );
  }
}

OfferFAQs.propTypes = {
  faqs: PropTypes.array.isRequired,
};

FAQItem.propTypes = {
  answer: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
};

export default OfferFAQs;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/OfferFAQs.js